<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="topBar"></div>
    <div class="cardTop">
        <div class="bodyCard" v-if="applyForm && submitter">
            <div class="card">
              <div class="titleCard">
                <div class="reimburs">出差申请</div>
                <div class="claimStatus">{{convertState(applyForm.approvalState)}}</div>
              </div>
              <div class="LRstylebox titleCard">
                <span style="color: black;">{{submitter.staffUserName }}</span>
                <span>提交于{{applyForm.createdAt}}</span>
              </div>
            </div>
        </div>
    </div>
    <el-tabs type="border-card"  @tab-click="handleClick">
      <el-tab-pane label="基本信息">
        <div class="bodyCard">
        <div class="card">
        <div class="line">基本信息</div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple"v-if="List && List.length > 0">
                <ul v-for="item in List" :key="item.index">
                  <li class="LRstyle">
                    <span>出差申请单号</span>
                    <span>{{item.ApplyCode}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出差开始时间</span>
                    <span>{{item.ApplyStartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出差结束时间</span>
                    <span>{{item.ApplyEndDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出差目的</span>
                    <span>{{item.ActionType}}</span>
                  </li>

                  <div v-show="item.ActionType !== '因私出行'">
                    <li class="LRstyle">
                      <span>是否长差</span>
                      <span>
                        <el-radio v-model="LongApplyFor" label="1" disabled>是</el-radio>
                        <el-radio v-model="LongApplyFor" label="2" disabled>否</el-radio>
                      </span>
                    </li>
                    <li class="LRstyle">
                      <span>预算</span>
                      <span>{{item.Amount}}</span>
                    </li>
                    <li class="LRstyle">
                      <span>国际出差</span>
                      <span>{{item.International==1?"是":"否"}}</span>
                    </li>
                  </div>

                  <li class="LRstyle">
                    <span>备注</span>
                    <el-tooltip class="item" effect="dark" :content="item.Remark" placement="top-end">
                    <span class="remark-text">{{item.Remark}}</span>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          出行人
          <span>（{{Travellers ? Travellers.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="Travellers && Travellers.length>0">
                <ul v-for="item in Travellers" :key="item.index">
                  <li class="LRstyle">
                    <span>姓名</span>
                    <span>{{item.Name}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>手机号</span>
                    <span>{{item.Phone}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>邮箱</span>
                    <span>{{item.Email}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          出差城市
          <span>（{{Destinations ? Destinations.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class=" bg-purple" v-if="Destinations && Destinations.length>0" style="display: flex;flex-wrap: wrap;">
                <div v-for="item in Destinations" :key="item.index" style="width: 50%;" class="LRstyle">
                  {{item.name}}
                </div>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          交通计划
          <span>（{{TrafficPlan ? TrafficPlan.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="TrafficPlan && TrafficPlan.length>0">
                <ul v-for="item in TrafficPlan" :key="item.index">
                  <li class="LRstyle">
                    <span>交通工具</span>
                    <span>{{item.TrafficType}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出发地</span>
                    <span>{{item.StartCity}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>目的地</span>
                    <span>{{item.EndCity}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>时间</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <!--自定义表单 -->
        <div class="titleLine">
          自定义表单
          <span></span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple"  v-if="CustomFieldInstances && CustomFieldInstances.length > 0">
                <ul v-for="item in CustomFieldInstances" :key="item.index">
                  <li class="LRstyle">
                    <span>{{item.fieldName}}</span>
                     <el-tooltip class="item" effect="dark"  v-if="item.fieldValues &&item.fieldValues.length > 0"
                        :content="item.fieldValues.join()" placement="top-end">
                     <span class="remark-text"  v-for="(it,idx) in item.fieldValues" :key="idx">{{it+" "}}</span>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          住宿计划
          <span>（{{HotelPlan ? HotelPlan.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="HotelPlan && HotelPlan.length>0">
                <ul v-for="item in HotelPlan" :key="item.index">
                  <li class="LRstyle">
                    <span>城市</span>
                    <span>{{item.City}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>入住时间</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>离开时间</span>
                    <span>{{item.EndDate}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="titleLine">
          附件信息
          <span>（{{fileRepertories ? fileRepertories.length : 0}}）</span>
        </div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div
                class="grid-content bg-purple"
                v-if="fileRepertories && fileRepertories.length>0"
              >
                <span v-for="item in fileRepertories" :key="item.index">
                  <img src v-lazy="item.url" alt="附件信息" class="fileRepertories" />
                </span>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
          <span>请填写审批意见！</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
        </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="审批意见" @click="click()">
            <el-form ref="form" :model="form" label-width="80px">
                <div class="bodyCard">
                    <div class="card">
                        <el-form-item class="label-suggest" label="填写审批意见" prop="suggest">
                            <el-input type="textarea" v-model="form.suggest"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item  v-if="!isDisplay">
                    <el-button type="text" class="goback">
                    <div @click="onCancel" class="fail-button">
                        <div>取消</div>
                    </div>
                    <div @click="open2" class="success-button">
                        <img src="@/assets/tongyi.png" alt="">
                        <div>同意</div>
                    </div>
                </el-button>
                </el-form-item>
                <el-form-item class="btn-suggest goback" v-if="isDisplay">
                    <div @click="onCancel" class="fail-button">
                        <div>取消</div>
                    </div>
                    <div @click="onReject" class="success-button">
                      <img src="@/assets/tongyi.png" alt="">
                      <div>拒绝</div>
                    </div>
                </el-form-item>
            </el-form>
      </el-tab-pane>
      <el-tab-pane label="审批记录">
        <div class="bodyCard">
        <div class="card">
        <div class="suggest-box info-box">
            <el-row :gutter="10">
                <div class="block">
                    <el-timeline v-if="AuditHistory  && AuditHistory.length > 0">
                        <el-timeline-item
                        v-for="(activity, index) in AuditHistory"
                        :key="index"
                        :timestamp="activity.CreateDate">
                        <div class="container">
                            <div class="row">
                                <span class="label" v-if="activity.UserName">操作人：</span><span>{{activity.UserName}}</span>
                            </div>
                            <div class="row" v-if="activity.Status">
                                <span class="label">状态：</span><span>{{activity.Status}}</span>
                            </div>
                            <div class="row" v-if="activity.Suggestion">
                                <span class="label">备注：</span><span>{{activity.Suggestion}}</span>
                            </div>
                        </div>
                        </el-timeline-item>
                    </el-timeline>
                    <div v-else>暂无数据</div>
                </div>
            </el-row>
        </div>
        </div>
    </div>
      </el-tab-pane>
    </el-tabs>
    <el-button type="text" class="goback" v-if="tabId !== 'tab-1'">
         <div class="fail-button"  @click="open3">
             <img src="@/assets/jujue.png" alt="">
             <div>拒绝</div></div>
         <div class="success-button"  @click="onApprove">
             <img src="@/assets/tongyi.png" alt="">
             <div>同意</div></div>
     </el-button>
  </div>
</template>
<script>
import { getApiURL } from "../config";
export default {
  data() {
    return {
      id: this.$route.query.id,
      List: [],
      ActionType: [],
      TrafficPlan: [],
      Travellers: [],
      HotelPlan: [],
      AuditHistory: [],
      fileRepertories: [],
      LongApplyFor: "1",
      tabId: "",
      activeIndex: "1",
      activeIndex2: "1",
      centerDialogVisible: false,
      CustomFieldInstances: [],
      form: {
        suggest: "",
      },
      message: "",
      fullscreenLoading: false,
      isDisplay:false,
      Destinations:[],
      applyForm:{},
      submitter:{},
    };
  },
  methods: {
    convertState (state) {
        switch (state) {
            case -1:
            default:
                return "未提交"
            case 0: return "审批中"
            case 1: return "已通过"
            case 2: return "被驳回"
        }
    },
    getTokenCode(){
        let fs_token = localStorage.fs_token;
        let rxToken = localStorage.rx_token;
        let markType = sessionStorage.markType;
        let doType=sessionStorage.doType;
        let deviceType=sessionStorage.deviceType;//判断他是pc端还是移动端

        let token_type
        let rx_token

        if (markType) {
            if (deviceType==='mobile') {
                token_type='FEI_SHU_TOKEN';// 审批
                rx_token=fs_token;
            }else if(deviceType==='pc') {
                token_type='UNIFIED_OFFICE_TODO';// pc
                rx_token=rxToken;
            }
            if (!doType) {
                token_type='UNIFIED_OFFICE_TODO';//即使通信 统一办公PC端
                rx_token=rxToken;
            }
        } else {
            if (rxToken) {
                token_type='RUI_XIN';
                rx_token=rxToken;
            }else{//作废
                token_type='FEI_SHU_TOKEN';
                rx_token=fs_token;
            }
        }

        return { token_type, rx_token };
    },
    getToken(){
        let fs_token = localStorage.fs_token;
        let rxToken = localStorage.rx_token;
        let markType = sessionStorage.markType;
        let doType=sessionStorage.doType;
        let deviceType=sessionStorage.deviceType;//判断他是pc端还是移动端

        let token_type
        let rx_token

        if (markType) {
            if (deviceType==='mobile') {
                token_type='FEI_SHU_CODE';// 审批
                rx_token=fs_token;
            }else if(deviceType==='pc') {
                token_type='UNIFIED_OFFICE_TODO';// pc
                rx_token=rxToken;
            }
            if (!doType) {
                token_type='UNIFIED_OFFICE_TODO';//即使通信 统一办公PC端
                rx_token=rxToken;
            }
        } else {
            if (rxToken) {
                token_type='RUI_XIN';
                rx_token=rxToken;
            }else{//作废
                token_type='FEI_SHU_CODE';
                rx_token=fs_token;
            }
        }

        return { token_type, rx_token };
    },
    getFeishu(){
    // 获取 URL 中的参数
    const urlParams = new URLSearchParams(window.location.search);
    let code = urlParams.get('code');

        if (code) {
           // 存储授权码
          localStorage.setItem("fs_token", code);
          // 处理授权码
          this.getDetail();
          // 删除 code 参数并保留其他参数
          urlParams.delete('code');
          const newQueryString = urlParams.toString();
          const newUrl = `${window.location.origin}${window.location.pathname}${newQueryString ? '?' + newQueryString : ''}`;
          // 更新浏览器地址栏中的 URL，但不刷新页面
          window.history.replaceState({}, document.title, newUrl);
        } else {
            // 构建授权 URL
            const redirectUri = encodeURIComponent(window.location.href);
            const appId = 'cli_a6d43c60a2f8d366';
            const state = 'STATE'
            const authUrl=`https://open.fklzl.cnpc.com.cn/open-apis/authen/v1/authorize?app_id=${appId}&redirect_uri=${redirectUri}&state=${state}`
           // 重定向到授权页面
            window.location.href = authUrl;
        }
    },
    setMarkType() {
        let markType = sessionStorage.markType;
        let platform = sessionStorage.platform;
        let deviceType=sessionStorage.deviceType;

        if (markType) {
            if (deviceType==='mobile') {//审批
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(() => {
                 window.close()
                }, 1500)
            }else if(deviceType==='pc'){
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(() => {
                  window.close()
                }, 1500)
            }
            if (platform) {//即时通信
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(()=>{
                    wx.closeWindow();
                },1500)
            }else{//pc
                this.$loading({
                $loading: true,
                text: '保存成功'
                })
                setTimeout(()=>{
                    window.close();
                },1500)
            }

        } else {
            this.$loading({
                $loading: true,
                text: '同步待办处理中'
            })
            setTimeout(() => {
                window.location.replace("https://app.cnpc.com.cn:8443/rxshared/private_todo/");
            }, 3000)
        }
    },
    // 驳回
    onReject() {
      let rootUrl = getApiURL("");
      let FlowId = localStorage.FlowId;
      let suggest =this.form.suggest;

      const ret = this.getTokenCode();

    const params = {
        ...ret,
        p_code: "RFCAIWU",
        encrypted: "1",
        data: {
        ComType: "ApplyReturn",
        FlowID:FlowId,
        Suggestion: suggest
        }
     }

      this.$http({
        method: "post",
        dataType: "jsonp",
        url:
          rootUrl +
          "/process?req_data=" +
          encodeURIComponent(
           JSON.stringify(params)
          ),
      }).then((res) => {
         this.setMarkType();
      });
    },
    //取消
    onCancel() {
      document.getElementById("tab-0").click();
    },
    open2() {
      this.$confirm("确认通过此业务申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          let rootUrl = getApiURL("");
          let FlowId = localStorage.FlowId;
          let suggest = this.form.suggest;

          const ret = this.getTokenCode();

        const params = {
            ...ret,
            p_code: "RFCAIWU",
            encrypted: "1",
            data: {
                ComType: "SubmitApply",
                FlowID: FlowId,
                Suggestion: suggest
            }
        }

          this.$http({
            method: "post",
            dataType: "jsonp",
            url:
              rootUrl +
              "/process?req_data=" +
              encodeURIComponent(
               JSON.stringify(params)
              ),
          }).then((res) => {
          this.setMarkType();
          });
        })
        .catch(() => {});
    },
    // 通过
    onApprove(){
        document.getElementById("tab-1").click();
    },
    open3() {
      this.$confirm("驳回时意见不能为空", "提示", {
        confirmButtonText: "确定",
        type: "info",
      })
        .then(() => {
          document.getElementById("tab-1").click();
          this.isDisplay=true;
        })
        .catch(() => {});
    },
    handleClick(tab, event) {
      let $this = this;
      $this.isDisplay=false;
      $this.tabId = event.target.id;
    },
    getDetail() {
      let $this = this;
      let rootUrl = getApiURL("");
      let FlowId = localStorage.FlowId;
      $this.fullscreenLoading = true;

      const ret = this.getToken();

    const params = {
        ...ret,
        p_code: "RFCAIWU",
        encrypted: "1",
        data: {
            ComType: "GetApplyDetails",
            FlowID: FlowId,
            FlowTypeID: 2
        }}

      this.$http({
        method: "post",
        dataType: "jsonp",
        url:
          rootUrl +
          "/process?req_data=" +
          encodeURIComponent(
           JSON.stringify(params)
          ),
      })
        .then(function (res) {
          $this.fullscreenLoading = false;

          let Data = res.data.data;

        if (Data.token) {
            localStorage.setItem("fs_token",Data.token)
        } else {
            localStorage.removeItem('fs_token')
        }
          let obj = {},
            list = new Array(obj);
          obj["ActionType"] = Data.ActionType;
          obj["Amount"] = Data.Amount;
          obj["ApplyCode"] = Data.ApplyCode;
          obj["ApplyEndDate"] = Data.ApplyEndDate;
          obj["ApplyStartDate"] = Data.ApplyStartDate;
          obj["International"] = Data.International;
          obj["Remark"] = Data.Remark;
          obj["UserName"] = Data.UserName;
          $this.List = list;
          $this.CustomFieldInstances = res.data.data.CustomFieldInstances; //自定义表单  数据
          $this.TrafficPlan = res.data.data.TrafficPlan;
          $this.Travellers = res.data.data.Travellers;
          $this.HotelPlan = res.data.data.HotelPlan;
          $this.fileRepertories = res.data.data.fileRepertories;
          $this.LongApplyFor = res.data.data.LongApplyFor == true ? "1" : "2";
          $this.AuditHistory = res.data.data.AuditHistory;
          $this.Destinations = res.data.data.destinations;
          $this.applyForm = res.data.data.applyForm;
          $this.submitter = res.data.data.submitter;
        })
        .catch(function (res) {
          $this.fullscreenLoading = false;
          $this.$router.push({ path: "*" });
        });
    },
  },
  mounted() {
    let rxToken = localStorage.rx_token;
    let markType=sessionStorage.markType;
    let doType=sessionStorage.doType;
    let deviceType=sessionStorage.deviceType;//判断他是pc端还是移动端

    if (markType) {
        if (deviceType==='mobile') {
            this.getFeishu()
        }else if(deviceType==='pc'){
            this.getDetail()
        }
        if (!doType) {
            this.getDetail()
        }
    }else{
        if (rxToken) {
            this.getDetail()
        }else {//代办应用 已废弃
            this.getFeishu()
        }
    }
  },
  components: {},
};
</script>
<style>
.el-tooltip__popper{
    max-width: 60%!important;
    text-align: center !important;
    line-height: 18px !important;
    padding: 5px !important;
}
.remark-text {
  display: inline-block !important;
  max-width: 120px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.el-tab-pane{
    margin-bottom: 75px !important;
}
.titleCard{
  margin: 16px !important;
  display: flex;
  align-items: center;
}
.reimburs{
  font-weight: 700;
  font-size: 18px;
  color: #222222;
}
.claimStatus{
  width: 55px;
  background-color: #D8E0FE ;
  display: inline-block;
  font-size: 12px;
  height: 20px;
  text-align: center;
  margin-left: 20px !important;
  line-height: 20px;
  border-radius: 4px;
  color: #2A57D8;
}
.titleName{
  font-size: 14px !important;
  color: #878d !important;
  list-style: none !important;
  display: flex !important;
  justify-content: space-between !important;
  height: 30px !important;
  line-height: 30px !important;
  border-bottom: 1px solid #edf2fc54 !important;
}
.topBar{
    width: 100%;
    height: 120px!important;
    display: flex;
    justify-content: center!important;
    align-items: center!important;
    z-index:1;
    background: linear-gradient(to bottom,#3370fe 0%,#fefefe 120px) !important;
}
.cardTop{
    display: flex;
    justify-content: center!important;
    align-items: center!important;
    margin-top: -80px!important;
    margin-bottom: 10px!important;
    width: 100%;
}

.bodyCard{
    display: flex!important;
    justify-content: center!important;
    align-items: center!important;
    margin: 0;
    margin-top: 20px!important;
    margin-bottom: 10px !important;
    width: 100%;
}

.card{
    width: 87%;
    background: #fff;
    border-radius: 8px;
    margin: 16px auto; /* 增加间距 */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.1) !important;
    transition: box-shadow 0.3s ease-in-out;
    padding: 5px !important;
}

.container {
  width: 100%;
  font-size: 16px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
  margin-bottom: 8px !important;
}

.label {
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
  width: 80px;
}

.el-timeline{
    margin-top: 15px !important;
}
.el-timeline-item__content{
    padding: 0px 30px 8px !important;
}
.el-timeline-item__timestamp{
    padding: 0px 30px 15px !important;
}

.fail-button {
  width: 41%;
  height: 36px!important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  cursor: pointer;
  text-align: center;
  margin-top: 5px  !important;
  font-weight: 500;
  font-size: 14px;
  color: #EB4C54;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EB4C54;
}
.fail-button img{
    width: 18px;
    margin-right: 5px !important;
}
.success-button img{
    width: 18px;
    margin-right: 5px !important;
}
.success-button{
  width: 41%;
  height: 36px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
  text-align: center;
  margin-top: 5px  !important;
  font-weight: 500;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #638BDB;
  line-height: 20px;
}

template {
  text-align: center !important;
}
th,
td {
  padding: 5px 0 !important;
}

.buttonCon {
  width: 100% !important;
  text-align: center !important;
  margin: 20px auto !important;
}
.line {
  height: 30px !important;
  line-height: 30px !important;
  text-indent: 15px !important;
  font-weight: 600;
  font-size: 16px;
}
.titleLine{
  background: #ffff !important;
  height: 30px !important;
  line-height: 30px !important;
  color: #222222 !important;
  text-indent: 15px !important;
  font-size: 14px;
}
.LRstylebox{
  font-size: 14px !important;
  color: #878d !important;
  list-style: none !important;
  display: flex !important;
  justify-content: space-between !important;
  height: 30px !important;
  line-height: 30px !important;
}
.LRstyle {
  font-size: 14px !important;
  color: #878d !important;
  list-style: none !important;
  display: flex !important;
  justify-content: space-between !important;
  height: 30px !important;
  line-height: 30px !important;
  border-bottom: 1px solid #edf2fc54 !important;
}
.LRstyle span:first-of-type {
  background: #FFFFFF;
  color: #ABABAB;
}

/* 第二个 span 的样式 */
.LRstyle span:last-of-type {
  background: #FFFFFF;
  color: black;

}
.fileRepertories {
  width: 30% !important;
  height: 100% !important;
  padding: 0 5px !important;
}
.el-tabs__content {
  padding: 0 !important;
}
.el-tabs__content_b {
  padding: 0 !important;
  height: 100vh !important;
}
.label-suggest {
    width: 100% !important;
    text-indent: 5 !important;
}
.goback {
  position: fixed !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 52px !important;
  border: 1px solid #dcdcdc !important;
  background-color: #f7f7f7 !important;
  z-index: 5 !important;
  border-bottom-width: 0 !important;
  padding: 0 !important;
  background: #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.1) !important;
}
.goback span {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border: none !important;
  display: flex !important;
  justify-content: space-around !important;
}
.el-tabs__nav-scroll{
  border-radius: 5px !important;
  display: flex;
  justify-content: space-around;
}
.el-tabs__nav {
  width: 87.5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px !important;
  background-color: #EFF0F2;
  border-radius: 16px;
  font-size: 14px;
  text-align: center;
  line-height: 32px !important;
  padding-left: 4px !important;
  padding-right:4px !important;
}
.el-tabs--border-card{
    border: none !important;
    -webkit-box-shadow:none !important;
    box-shadow: none !important;
}
.el-tabs--border-card>.el-tabs__header{
    border-bottom: 0px !important;
}

.el-tabs__item {
  text-align: center !important;
  font-size: 14px !important;
  padding:  0px 10px !important;
  height: 22px !important;
  line-height: 22px !important;
  text-align: center;
}
.el-tabs__item.is-active{
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    border-radius: 20px 20px !important;
    padding-bottom: 1px !important;
    font-weight: 550;
}

.el-tabs__header{
  background-color: #fff!important;
}

.el-form-item__label {
  width: 90% !important;
  text-align: left !important;
  height: 20px !important;
  line-height: 20px !important;
  font-size: 14px !important;
  margin: 16px 0px 14px 14px !important;
}
.el-textarea__inner{
    width: 91.5% !important;
    margin-left: 14px !important;
    margin-bottom: 16px !important;
    padding: 16px !important;
    font-family: "Arial", sans-serif;
}

.el-form-item__content {
  width: 100% !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: space-between !important;
}

.el-menu li {
  width: 50% !important;
  text-align: center !important;
  font-size: 18px !important;
}
.cell {
  text-align: center !important;
  font-size: 14px !important;
}
th,
td {
  padding: 5px 0 !important;
}

.el-icon-close {
  display: none !important;
}
.bg-purple ul {
  border-top: 1px solid #ddd !important;
}
.bg-purple ul:first-child {
  border-top: none !important;
}
.suggest-box {
  margin-bottom: 40px !important;
}
.info-box {
  padding: 0 15px !important;
}

.el-message-box__wrapper .el-message-box {
  width: 80% !important;
  height: 100px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__header {
  padding: 10px !important;
}

.el-message-box__wrapper
  .el-message-box
  .el-message-box__header
  .el-message-box__title
  span {
  font-size: 14px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__content {
  padding-left: 10px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__message {
  padding-left: 30px !important;
}

.el-message-box__wrapper .el-message-box .el-message-box__btns button {
  width: 50px !important;
  height: 25px !important;
  margin-right: 10px !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/businessApplication.vue